import {
  ActivateInhousePayrollDocument,
  ActivateInhousePayrollMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useActivateInhousePayroll = () => {
  const [ActivateInhouse, { loading }] = useMutation(ActivateInhousePayrollDocument, {
    extractorFn: (data: ActivateInhousePayrollMutation) =>
      data.payrollMutations.createPayrollInhouseActivation,
  })

  return {
    loading,
    activateInhousePayroll(companyId: number, incidenceOptionNames: string[] = []) {
      return ActivateInhouse({
        variables: { companyId: companyId, incidenceOptionNames: incidenceOptionNames },
      })
    },
  }
}
